// extracted by mini-css-extract-plugin
export var globe = "LanguageSelector-module--globe--98357";
export var option = "LanguageSelector-module--option--bdbdd";
export var selected = "LanguageSelector-module--selected--dd5f3";